import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CalendarTableS } from './CalendarTableS';

export const AfterDataHtmlS = (props: AfterDataHtmlSProps) => {
  return (
    <Swiper initialSlide={props.thisMonth} modules={[Navigation]} slidesPerView={1} navigation>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={0} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={1} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={2} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={3} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={4} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={5} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={6} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={7} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={8} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={9} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={10} />
      </SwiperSlide>
      <SwiperSlide>
        <CalendarTableS data={props.data} year={props.year} month={11} />
      </SwiperSlide>
    </Swiper>
  );
};
